import { atom } from "jotai";
import EnhancedContentManifestRecord from "models/view-models/enhanced-content-manifest-record";

const CurrentPublicationEnhancedContentManifests = atom<
    EnhancedContentManifestRecord[]
>([]);

export default CurrentPublicationEnhancedContentManifests;
